<template>
  <div class="row">
    <header-servico
      tipo="Encaminhamentos"
      :loading="loading"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando os Encaminhamentos da Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="encaminhamento" />

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!novo_encaminhamento"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <h5
                          class="font-weight-bold"
                          v-if="encaminhamentos_recebidos == 1"
                        >
                          Encaminhamentos
                        </h5>
                        <h5 class="font-weight-bold" v-else>
                          Encaminhamentos Recebidos
                        </h5>
                        <div>
                          <a
                            v-if="encaminhamentos_recebidos == 2"
                            class="router-link-exact-active active"
                            title="Encaminhamentos Enviados"
                            @click="encaminhamentos_recebidos = 1"
                          >
                            <i class="fas fa-file-export"></i>
                            Todos
                          </a>
                          <a
                            v-else
                            class="router-link-exact-active active"
                            title="Encaminhamentos Recebidos"
                            @click="encaminhamentos_recebidos = 2"
                          >
                            <i class="fas fa-file-import"></i>
                            Recebidos
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_encaminhamento = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div>
                          <div>
                            <b-button-group>
                              <b-button
                                variant="outline-dark"
                                :class="
                                  viewFilterReport === true ? 'active' : ''
                                "
                                @click="viewFilters"
                              >
                                <i class="fas fa-filter"></i>
                                {{ $t("Filtros") }}
                              </b-button>
                              <b-button variant="outline-dark" @click="print()">
                                <i class="fas fa-print"></i>
                              </b-button>
                              <b-button
                                variant="outline-dark"
                                @click="exportar()"
                                :title="$t('Exportar')"
                                v-b-tooltip.hover
                              >
                                <i class="fas fa-file-excel"></i>
                              </b-button>
                            </b-button-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" v-if="viewFilterReport">
                      <form
                        @submit.prevent="getEncaminhamentos"
                        ref="formFiltros"
                      >
                        <div class="row">
                          <form-calendar
                            v-model="data_inicio"
                            grid="4"
                            label="Data Inicial"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="4"
                            label="Data Final"
                            :required="verificaDataInicial"
                          />

                          <form-select
                            v-model="filtroStatus"
                            label="Status"
                            :itens="status"
                            grid="4"
                          />

                          <form-select
                            v-model="filtroFamiliar"
                            label="Pesquisar Familiar"
                            :itens="familiares"
                            grid="12"
                          />
                        </div>
                        <div
                          class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default btn-sm"
                              @click.prevent="
                                limparFiltros();
                                viewFilterReport = false;
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary btn-sm"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit btn-sm"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <load mode="table" v-if="loadingEncaminhamentos" />
                    <div class="col-12" v-else>
                      <span>
                        <a
                          v-if="!showName"
                          @click.prevent="mostrarNome"
                          href="#"
                          ><i class="fas fa-eye"></i> Mostrar Nome de
                          Registro</a
                        >
                        <a v-else @click.prevent="ocultarNome" href="#"
                          ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                          Registro</a
                        >
                      </span>
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'protocolo',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'created_at',
                              label: $t('Data'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="EncaminhamentosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            <i
                              class="mdi mdi-lock mdi-18px text-danger"
                              v-if="data.item.privado == 1"
                              v-b-popover.hover.top="
                                'Encaminhamento com sigilo'
                              "
                            ></i>
                            Usuário(s):<br />
                            <ul>
                              <li
                                v-for="pessoa in data.item.usuarios"
                                :key="pessoa.id"
                              >
                                <b v-if="!pessoa.nome_social">{{
                                  pessoa.nome_completo
                                }}</b>
                                <b v-else>
                                  {{ pessoa.nome_social }} ( N.R.: )
                                  <span v-if="showName">
                                    {{ pessoa.nome_completo }}</span
                                  >
                                </b>
                              </li>
                            </ul>
                            Protocolo:
                            <b>{{ data.item.protocolo }}</b>
                            <br />
                            Tipo: <b>{{ data.item.tipo.descricao }}</b>
                            <br />
                            Origem:
                            <b v-if="data.item.unidade">{{
                              data.item.unidade.nome
                            }}</b>
                            <br />
                            Técnico autor:
                            <b>{{ data.item.autor }}</b>

                            <span v-if="data.item.unidade_destino">
                              <br />
                              Unidade de Destino:
                              <b>{{ data.item.unidade_destino.nome }}</b>
                            </span>
                            <span
                              v-if="data.item.unidade_externa"
                              class="text-muted text-xs"
                            >
                              - Unidade Externa
                            </span>
                            <span v-if="data.item.tecnico_destino">
                              <br />
                              Técnico de Destinatário:
                              <b>{{ data.item.tecnico_destino.nome }}</b> -
                              <span>
                                {{
                                  data.item.tecnico_destino.profissao ??
                                  "Não informado"
                                }}
                              </span>
                            </span>
                          </template>
                          <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | formatDate() }}
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              v-if="user_id == data.item.user_id"
                              @click="redirectEncaminhamento(data.item.id)"
                              class="px-2 mb-0 btn btn-sm btn-success"
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>

                            <b-button
                              v-if="
                                (unidade_id == data.item.unidade_id ||
                                  unidade_id == data.item.unidade_destino_id) &&
                                (data.item.user_role ==
                                  'Técnico(a) Administrativo(a)' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSB' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSE' ||
                                  $store.state.user.role_details.name ==
                                    'Coordenador' ||
                                  $store.state.user.role_details.name ==
                                    'Gestor(a)' ||
                                  $store.state.user.role_details.name ==
                                    'Técnico(a) de Nível Superior')
                              "
                              :title="$t('Visualizar e Imprimir')"
                              :to="
                                '/dashboard/encaminhamentos/show/' +
                                data.item.id
                              "
                              class="px-2 mb-0"
                              size="sm"
                              type="button"
                              v-b-tooltip.hover
                              variant="primary"
                            >
                              <i class="mdi mdi-eye" />
                            </b-button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getEncaminhamentos"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoEncaminhamento
                  v-else
                  :familia="familia"
                  @voltar="novo_encaminhamento = false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NovoEncaminhamento from "./Add";
export default {
  components: { NovoEncaminhamento },
  name: "Encaminhamentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Encaminhamentos"),
    };
  },
  data() {
    return {
      showName: false,
      familia: {},
      novo_encaminhamento: false,
      TipoEncaminhamentosList: [],
      EncaminhamentosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingEncaminhamentos: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      user_id: null,
      unidade_id: null,
      encaminhamentos_recebidos: 1,
      filtroStatus: null,
      filtroDatas: [],
      status: [],
      filtroFamiliar: null,
      familiares: [],
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getStatus();
    this.getEncaminhamentos();
  },
  watch: {
    encaminhamentos_recebidos: function (newValue) {
      this.getEncaminhamentos(newValue);
    },
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getEncaminhamentos(encaminhamentos_recebidos = null) {
      this.loadingEncaminhamentos = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/encaminhamentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            encaminhamentos_recebidos: encaminhamentos_recebidos
              ? encaminhamentos_recebidos
              : 1,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroFamiliar: this.filtroFamiliar,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.unidade_id = this.$store.state.unidade;
          this.EncaminhamentosList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getEncaminhamentos();
          } else {
            this.loadingEncaminhamentos = false;
          }
        })
        .catch(() => {
          this.loadingEncaminhamentos = false;
        });
    },

    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/encaminhamentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroFamiliar: this.filtroFamiliar,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getEncaminhamentos();
      }
    },
    redirectEncaminhamento(id) {
      this.$router.push({
        path: `/dashboard/encaminhamentos/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;

          this.familiares = this.familia.familiares.map((elem) => ({
            id: elem.id,
            value: elem.nome_completo,
          }));

          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    getStatus() {
      axios.get(`api/dashboard/status/encaminhamentos`).then((response) => {
        this.status = response.data;
      });
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroDatas = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.getEncaminhamentos();
    },
  },
};
</script>
